import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import StepHeading from '../step_heading/step_heading.js';
import VariantOptions from '../variant_options/variant_options.js';
import LineItemOptions from '../line_item/line_item.js';
import { htmlDecode } from '../helpers.js';
import './step.css';

var _ref = React.createElement(
	'p',
	{ className: 'nameplate' },
	'Flex #999'
);

var Step = function (_Component) {
	_inherits(Step, _Component);

	function Step() {
		_classCallCheck(this, Step);

		return _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).call(this));
	}

	_createClass(Step, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    title = _props.title,
			    index = _props.index,
			    myImage = _props.myImage,
			    info = _props.info,
			    sub_note = _props.sub_note,
			    selections = _props.selections,
			    shopify_product = _props.shopify_product,
			    setVariantCheckbox = _props.setVariantCheckbox,
			    setVariantRadio = _props.setVariantRadio,
			    wkSelectedOptions = _props.wkSelectedOptions,
			    addLineItem = _props.addLineItem,
			    line_items = _props.line_items,
			    updateQuantity = _props.updateQuantity,
			    selection_note = _props.selection_note;
			// console.log("LINE ITESM%%%%", line_items)

			var row_title = 'STEP ' + (index + 1) + '  |  ' + title.toUpperCase();
			return React.createElement(
				'div',
				null,
				React.createElement(
					Collapsible,
					{ trigger: React.createElement(StepHeading, { row_title: row_title, index: index }), onOpening: function onOpening() {
							console.log('i am opening right now....');
						} },
					React.createElement(
						'p',
						null,
						info
					),
					React.createElement(
						'div',
						{ className: 'configuration' },
						React.createElement(
							'div',
							{ className: 'configuration-fields' },
							selections && selections.map(function (selection, s_index) {
								switch (selection.type) {
									case 'variants':
										return React.createElement(VariantOptions, {
											key: 'variant-' + s_index,
											select_by: selection.select_by,
											show_quantity: selection.show_quantity,
											shopify_product: shopify_product,
											wkSelectedOptions: wkSelectedOptions,
											step_index: index,
											setVariantCheckbox: setVariantCheckbox,
											setVariantRadio: setVariantRadio,
											updateQuantity: updateQuantity,
											selection: selection });
									case 'line_item':
										return React.createElement(LineItemOptions, {
											key: 'lineitem-' + s_index,
											select_by: selection.select_by,
											shopify_product: shopify_product,
											maxlength: selection.maxlength,
											wkSelectedOptions: line_items,
											step_index: index,
											addLineItem: addLineItem,
											setVariantRadio: setVariantRadio,
											selection: selection });
								}
							}),
							sub_note && React.createElement('div', { className: 'sub_note', dangerouslySetInnerHTML: { __html: htmlDecode(sub_note) } })
						),
						React.createElement(
							'div',
							{ className: 'step_image' },
							React.createElement('img', { src: myImage, alt: 'placeholder image' }),
							React.createElement(
								'div',
								{ className: 'step_image_text' },
								line_items.map(function (line_item) {
									if (line_item.name === 'Line 1 Text' && title.includes('Name Plate')) {
										return React.createElement(
											'p',
											{ className: 'nameplate' },
											line_item.value
										);
									}
								}),
								line_items.map(function (line_item) {
									if (line_item.name === 'Line 2 Text' && title.includes('Name Plate')) {
										return React.createElement(
											'p',
											{ className: 'nameplate' },
											line_item.value
										);
									}
								}),
								title.includes('Name Plate') && _ref
							)
						)
					)
				)
			);
		}
	}]);

	return Step;
}(Component);

export default Step;